// LEO RADAR — static data (MVP, no backend).
// Two sections: POTWIERDZONY ETAP + DO OBSERWACJI.
// Count is derived from array length (never hardcode 9/14/15).

export const RADAR_LAST_UPDATE = "30.10.2026";
export const RADAR_NEXT_UPDATE = "16.11.2026";
export const RADAR_LAST_UPDATE_SHORT = "30.10";
export const RADAR_NEXT_UPDATE_SHORT = "16.11";

export const RADAR_MISSING_TEXT = "Brak potwierdzonych publicznych informacji";
export const RADAR_MISSING_DATE_TEXT = "Brak potwierdzonego terminu";

// FREE / SINGLE / SPRINT users see this single full record on /radar.
export const RADAR_FREE_SAMPLE_ID = "damscy-kaznodzieje";

export const RADAR_UNLOCKED_PLANS = new Set(["start", "monthly", "annual", "light"]);
export function radarUnlocked(access) {
  return RADAR_UNLOCKED_PLANS.has(access?.plan);
}

// Section 1 — projects whose current stage is publicly confirmed.
export const RADAR_CONFIRMED = [
  {
    id: "jantar",
    title: "JANTAR",
    type: "film fabularny / biograficzny",
    status: "PREPRODUKCJA / CASTING OTWARTY",
    director: "Daniel Jaroszek",
    producer: "Robert Kijak",
    script: "Daniel Jaroszek, Tatiana Zawrzykraj-Kutz",
    shootPeriod: "2027 (planowane)",
    castingUrl: "https://casting.jantarfilm.com",
    whyOnRadar: "Trwa casting aktorek w wieku 18–35 lat do głównej roli. Termin zgłoszeń: 20.11.2026. Zdjęcia planowane na 2027 rok.",
  },
  {
    id: "damscy-kaznodzieje",
    title: "DAMSCY KAZNODZIEJE",
    type: "film fabularny",
    status: "DEVELOPMENT / FINANSOWANIE",
    director: "Natasza Parzymies",
    producer: "Koi Studio",
    financing: "dofinansowanie PISF",
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026. W sierpniu 2026 pojawiła się informacja o dofinansowaniu PISF.",
  },
  {
    id: "historia-domu-fiedlerow",
    title: "HISTORIA DOMU FIEDLERÓW",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Emi Buchwald",
    producer: "Telemark",
    producerPerson: "Piotr Śmiechowski",
    whyOnRadar:
      "Projekt prezentowany jako projekt developmentowy podczas Polish Days 2026.",
  },
  {
    id: "wyprawa",
    title: "WYPRAWA",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Kei Ishikawa",
    script: "Kei Ishikawa, Łukasz Czapski",
    producer: "Lava Films",
    producerPerson: "Marta Gmosińska",
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026.",
  },
  {
    id: "polka",
    title: "POLKA",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Kalina Alabrudzińska",
    producer: "WIR",
    producerPerson: "Michał Kiedrowicz",
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026.",
  },
  {
    id: "plemie",
    title: "PLEMIĘ",
    type: "film",
    status: "DEVELOPMENT",
    director: "Olga Chajdas",
    producer: null,
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026.",
  },
  {
    id: "sasiedztwo",
    title: "SĄSIEDZTWO",
    type: "film",
    status: "DEVELOPMENT",
    director: "Michał Chmielewski",
    producer: "Fundacja Filmowa Lumisenta",
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026.",
  },
  {
    id: "koniec-swiata",
    title: "KONIEC ŚWIATA",
    type: "film",
    status: "DEVELOPMENT",
    director: "Tomasz Śliwiński",
    producer: "Autograf Film",
    whyOnRadar:
      "Projekt prezentowany w sekcji developmentowej Polish Days 2026.",
  },
  {
    id: "ktr",
    title: "K.T.R.",
    type: "film",
    status: "PREPRODUKCJA",
    country: "Polska",
    language: "angielski",
    director: "Heathcliff Janusz Iwanowski",
    producer: "Global Studio",
    whyOnRadar: "Projekt jest publicznie oznaczony jako Pre-production.",
  },
  {
    id: "the-passenger",
    title: "THE PASSENGER",
    type: "film międzynarodowy",
    status: "FINANSOWANIE / PRZYGOTOWANIE PRODUKCJI",
    language: "angielski",
    director: "Magnus von Horn",
    plProducer: "Lava Films / Mariusz Włodarski",
    coProducers: "Port au Prince Films",
    financing: "FilmNation",
    knownCast: "Jeremy Strong",
    shootPeriod: "Termin niepotwierdzony",
    whyOnRadar:
      "Anglojęzyczny projekt Magnusa von Horna z polskim producentem Lava Films. Jeremy Strong jest publicznie potwierdzony w głównej roli. Projekt otrzymał również wsparcie Dolnośląskiego Funduszu Filmowego.",
  },
  {
    id: "solistka",
    title: "SOLISTKA",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Marta Prus",
    knownCast: "Brak potwierdzonych publicznych informacji",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "Brak potwierdzonego terminu",
    whyOnRadar:
      "Projekt prezentowany jako projekt developmentowy podczas Polish Days 2026.",
  },
  {
    id: "moj-dom",
    title: "MÓJ DOM",
    internationalTitle: "The Calling",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Filip Syczyński",
    knownCast: "Brak potwierdzonych publicznych informacji",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "Brak potwierdzonego terminu",
    whyOnRadar:
      "Projekt prezentowany jako projekt developmentowy podczas Polish Days 2026.",
  },
  {
    id: "toxic",
    title: "TOXIC",
    type: "film fabularny",
    status: "DEVELOPMENT",
    director: "Dawid Nickel",
    knownCast: "Brak potwierdzonych publicznych informacji",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "Brak potwierdzonego terminu",
    whyOnRadar:
      "Projekt prezentowany jako projekt developmentowy podczas Polish Days 2026.",
  },
  {
    id: "milka",
    title: "MIŁKA",
    type: "film fabularny",
    status: "PRODUKCJA / ZDJĘCIA",
    director: "Katarzyna Warzecha",
    producer: "Studio Produkcyjne Orka",
    knownCast: "Sandra Drzymalska, Mirosław Zbrojewicz",
    shootPeriod: "wrzesień 2026",
    shootLocation: "Podkarpacie / Bieszczady",
    whyOnRadar:
      "Zdjęcia do filmu rozpoczęły się we wrześniu 2026 na Podkarpaciu. Projekt jest wspierany przez Podkarpacki Regionalny Fundusz Filmowy.",
  },
  {
    id: "zwierzak",
    title: "ZWIERZAK / THE HIDDEN BEAST",
    type: "serial kryminalny",
    country: "Polska",
    platform: "SkyShowtime",
    status: "PRODUKCJA / ZDJĘCIA",
    director: "Adrian Panek",
    script: "Marcin Ciastoń",
    producer: "MediaBrigade",
    producerPerson: "Marcin Kurek, Sylwester Banaszkiewicz",
    knownCast:
      "Piotr Witkowski, Borys Szyc, Zofia Jastrzębska, Eryk Kulm, Vanessa Aleksander",
    shootPeriod: "zdjęcia trwają",
    shootLocation: "Polska, w tym Legnica",
    whyOnRadar:
      "SkyShowtime potwierdził produkcję serialu. We wrześniu 2026 realizowano zdjęcia m.in. w Legnicy.",
  },
  {
    id: "wszystko-pod-kontrola",
    title: "WSZYSTKO POD KONTROLĄ",
    type: "serial / komediodramat",
    country: "Polska",
    platform: "Disney+ / Hulu Original",
    status: "PRODUKCJA / ZDJĘCIA",
    director: "Maria Zbąska, Jakub Piątek",
    script: "Lynn Kucharczyk",
    producer: "OPUS TV",
    knownCast:
      "Oliwia Drożdżyk, Monika Frajczyk, Nicolas Przygoda, Michał Sikorski",
    shootPeriod: "od 14.09.2026",
    shootLocation: "Polska",
    whyOnRadar:
      "Zdjęcia do nowego polskiego serialu Disney+ rozpoczęły się 14 września 2026. Publicznie ujawniono część obsady.",
  },
  {
    id: "la-manche",
    title: "LA MANCHE",
    type: "film fabularny / koprodukcja międzynarodowa",
    country: "Polska / Niemcy / Francja",
    status: "DEVELOPMENT / FINANSOWANIE",
    director: "Damian Kocur",
    producer: "Kijora Film",
    producerPerson: "Anna Gawlita, Marta Szymanowska",
    coProducers: "Oma Inge Film & Kultur, Les Contes Modernes",
    financing: "Eurimages",
    shootPeriod: "Termin niepotwierdzony",
    shootLocation: "realizacja planowana w Polsce",
    whyOnRadar:
      "Nowy film Damiana Kocura znajduje się na etapie developmentu jako międzynarodowa koprodukcja. Projekt otrzymał wsparcie Eurimages.",
  },
  {
    id: "marysia-zawsze-dziewica",
    title: "MARYSIA ZAWSZE DZIEWICA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Anna Jadowska",
    producer: "Mozaika Films",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "hana",
    title: "HANA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Milan Cieslar",
    producer: "MediaBrigade",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "ksiega-rekordow",
    title: "KSIĘGA REKORDÓW / MALIGNUM",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Kordian Kądziela",
    producer: "TFP",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "czarna-woda",
    title: "CZARNA WODA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Aga Woszczyńska, Łukasz Czapski",
    producer: "Lava Films",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "mala-niebieska-kropka",
    title: "MAŁA NIEBIESKA KROPKA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Dominik Czech",
    producer: "Szeroki Kąt",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "smierc-czeskiego-psa",
    title: "ŚMIERĆ CZESKIEGO PSA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Paweł Sroka",
    producer: "Emma Production",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "pod-presja",
    title: "POD PRESJĄ",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Zuza Marczak",
    producer: "24fps",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "jedz-i-nie-mow-do-mnie-jak-do-zony",
    title: "JEDZ I NIE MÓW DO MNIE JAK DO ŻONY",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Kinga Dębska",
    producer: "Studio Produkcyjne Orka",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "wanda",
    title: "WANDA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Adrian Panek",
    producer: "WFDiF",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "vetustas-tu-i-teraz",
    title: "VETUSTAS. TU I TERAZ!",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Mariusz Palej",
    producer: "Running Rabbit Films",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "incydent",
    title: "INCYDENT",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Tomasz Wolski",
    producer: "Kijora Film",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "legacy-brzemie",
    title: "LEGACY / BRZEMIĘ",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Aliaksei Paluyan",
    producer: "Lava Films",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "matka-corka",
    title: "MATKA CÓRKA",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Marta Ojrzyńska",
    producer: "Rizz Films",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "przygody-baltazara-gabki",
    title: "PRZYGODY BALTAZARA GĄBKI",
    type: "film",
    status: "PROJEKT POTWIERDZONY",
    director: "Krzysztof Komander",
    producer: "Warszawska Wytwórnia Filmowa",
    whyOnRadar:
      "Projekt potwierdzony. Brak publicznego potwierdzenia rozpoczęcia zdjęć ani otwartego castingu.",
  },
  {
    id: "miedzy-cisza-a-szeptem",
    title: "MIĘDZY CISZĄ A SZEPTEM",
    type: "film",
    status: "PRODUKCJA / ZDJĘCIA",
    director: "Michał Kondrat",
    producer: null,
    whyOnRadar:
      "Potwierdzony etap produkcji / zdjęć.",
  },
];

// Section 2 — projects with a fresh credible signal but unconfirmed stage.
export const RADAR_OBSERVATION = [
  {
    id: "smieszny-czlowiek",
    title: "ŚMIESZNY CZŁOWIEK",
    type: "film",
    status: "ETAP NIEPOTWIERDZONY",
    director: "Maciej Buchwald",
    script: "Maciej Buchwald, Grzegorz Uzdański",
    producer: "Apple Film Production",
    signal:
      "Projekt jest publicznie wykazywany jako będący w toku i związany z produkcją we Wrocławiu.",
  },
  {
    id: "irka",
    title: "IRKA",
    type: "film",
    status: "ETAP NIEPOTWIERDZONY",
    director: "Mateusz Pacewicz",
    producer: "Aurum Film",
    signal:
      "Świeże finansowanie Mazowieckiego i Warszawskiego Funduszu Filmowego 2026.",
  },
  {
    id: "wniebogos",
    title: "WNIEBOGŁOS",
    type: "film",
    status: "ETAP NIEPOTWIERDZONY",
    director: "Patrycja Polkowska",
    producer: "Fundacja Filmowa Lumisenta",
    signal:
      "Finansowanie regionalne 2026, w tym wsparcie Mazowieckiego i Warszawskiego Funduszu Filmowego oraz Podkarpackiego Regionalnego Funduszu Filmowego.",
  },
  {
    id: "krowa",
    title: "KROWA",
    type: "film",
    status: "ETAP NIEPOTWIERDZONY",
    director: "Kristoffer Rus",
    producer: "Pokromski Studio",
    signal: "Finansowanie Podkarpackiego Regionalnego Funduszu Filmowego 2026.",
  },
  {
    id: "lakome",
    title: "ŁAKOME",
    type: "film fabularny",
    status: "FINANSOWANIE / PRZYGOTOWANIE",
    director: "Jagoda Szelc",
    producer: "Shipsboy",
    knownCast: "Izabella Dudziak, Małgorzata Trofimiuk, Cezary Żak",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "planowane na 2027",
    signal:
      "Projekt otrzymał finansowanie regionalne w 2026. Publiczne informacje wskazują na przygotowania do realizacji. Część obsady jest już znana.",
  },
  {
    id: "wilcze-dzieci",
    title: "WILCZE DZIECI",
    type: "film fabularny",
    status: "FINANSOWANIE / ETAP NIEPOTWIERDZONY",
    director: "Radosław Dunaszewski",
    producer: "Metro Films",
    knownCast: "Brak potwierdzonych publicznych informacji",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "Brak potwierdzonego terminu",
    signal:
      "Projekt otrzymał finansowanie Dolnośląskiego Funduszu Filmowego w 2026. Brak publicznego potwierdzenia rozpoczęcia zdjęć.",
  },
  {
    id: "obiady-domowe",
    title: "OBIADY DOMOWE",
    type: "film fabularny",
    status: "FINANSOWANIE / PRZYGOTOWANIE",
    director: "Piotr Trzaskalski",
    producer: "Serce",
    knownCast: "Agata Kulesza, Andrzej Chyra",
    castingDirector: "Brak potwierdzonych publicznych informacji",
    shootPeriod: "Brak potwierdzonego terminu",
    signal:
      "Projekt otrzymał finansowanie Łódzkiego Funduszu Filmowego 2026. Publicznie informowano o kompletowaniu budżetu. Część obsady jest już znana.",
  },
  {
    id: "untitled-opus-tv-lubuskie",
    title: "UNTITLED OPUS TV / LUBUSKIE",
    type: "serial kryminalny / thriller policyjny",
    status: "PRODUKCJA / ZDJĘCIA – TYTUŁ NIEUJAWNIONY",
    director: "Maciej Pieprzyca",
    producer: "OPUS TV",
    signal:
      "OPUS TV realizuje w województwie lubuskim nieujawniony serial kryminalny. Publiczne informacje wskazują Macieja Pieprzycę jako reżysera oraz Andrzeja Chyrę, Rafaela Stachowiaka i Roberta Wrzoska jako członków obsady.",
  },
  {
    id: "untitled-xix-century-series",
    title: "UNTITLED XIX-CENTURY SERIES",
    type: "serial historyczny / kostiumowy",
    status: "PRODUKCJA / PROJEKT NIEZIDENTYFIKOWANY",
    signal:
      "Trwa realizacja produkcji kostiumowej osadzonej około 1840 roku. Zdjęcia realizowane są w Polsce i Czechach, m.in. w Lubiążu, Sosnowcu, Krakowie, Lublinie i Jaroměř. MKM Studio prowadzi nabory statystów. Blok zdjęciowy w Lublinie planowany jest na 20–28.10.2026.",
  },
];

export const RADAR_TOTAL_COUNT =
  RADAR_CONFIRMED.length + RADAR_OBSERVATION.length;

export const RADAR_ARCHIVE = [
  {
    id: "noce-i-dnie",
    title: "NOCE I DNIE",
    type: "serial",
    country: "Polska",
    platform: "Netflix",
    status: "ARCHIWUM — ZDJĘCIA ZAKOŃCZONE",
    director: "Kamila Tarabura",
    script: "Marta Bacewicz, Katarzyna Tybinka, Kamila Tarabura",
    producer: "Greenlight Films",
    producerPerson: "Justyna Pawlak",
    knownCast: "Jaśmina Polak, Tomasz Schuchardt",
    castingDirector: "Nadia Lebik",
    shootPeriod: "wrzesień–październik 2026",
    shootLocation: "m.in. Tarnów",
    whyOnRadar:
      "Nowa serialowa adaptacja „Nocy i dni” dla Netflixa jest w produkcji. Zdjęcia rozpoczęły się we wrześniu 2026. Publicznie ujawniono pierwszych członków obsady.",
  },
];
